import { atom } from "jotai";

export const isExportPdfViewOpenAtom = atom(false);
export const isExportPngViewOpenAtom = atom(false);
export const isCursorLearnMoreOpenAtom = atom(false);
